module.exports = __webpack_public_path__ + "static/7-069c0d143b2dca33a07bc82e3fe881b6.jpg";